module.exports = __webpack_public_path__ + "img/monitor-icon10.76d65008.png";